import { render, staticRenderFns } from "./FormSheetTable.vue?vue&type=template&id=4f2aae24&"
import script from "./FormSheetTable.vue?vue&type=script&lang=ts&"
export * from "./FormSheetTable.vue?vue&type=script&lang=ts&"
import style0 from "./FormSheetTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VCardText,VDivider,VPagination})
